module.exports = __webpack_public_path__ + "img/27_43.1f844e66.png";